import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import styles from './list-item.module.scss';

const ActionLink = ({to, children}) => (
  <li>
    <Link to={to} className={styles.listItem}>
      {children}
    </Link>
  </li>
);

ActionLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
};

export default ActionLink;
